import { CommonModule } from '@angular/common';
import { Injectable, NgModule, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  CORE_I18N_FOLDER,
  CORE_PAGE_MODULE,
  CorePageModule,
  CorePageModuleIDs,
  CoreSelectorGuard
} from '@bepatient/core';
import {
  MyMeasuresActionLoadChart,
  MyMeasuresStoreModule,
  selectorMyMeasureGraph
} from '@bepatient/my-measures-store';
import { IonicModule } from '@ionic/angular';
import { Store } from '@ngrx/store';

@Injectable()
export class MyMeasuresGraphGuard extends CoreSelectorGuard {
  constructor() {
    const store = inject<Store<any>>(Store);

    super(store, selectorMyMeasureGraph, new MyMeasuresActionLoadChart());
  }
}

const pageModule: CorePageModule = {
  ID: CorePageModuleIDs.MY_MEASURES,
  i18nLabel: 'MODULES.MY_MEASURES',
  icon: 'pulse',
  leftMenuAvailableForPages: [0, 1, 2, 4],
  routes: [
    {
      path: 'my-measures',
      loadChildren: () =>
        import('./pages/my-measures/my-measures.module').then(
          m => m.MyMeasuresPageModule
        )
    },
    {
      path: 'my-measures-graph-chartjs',
      loadChildren: () =>
        import(
          './pages/my-measures-graph-chartjs/my-measures-graph-chartjs.module'
        ).then(m => m.MyMeasuresGraphChartJSPageModule)
    },
    {
      path: 'my-measures-graph-highcharts',
      canActivate: [MyMeasuresGraphGuard],
      loadChildren: () =>
        import(
          './pages/my-measures-graph-highcharts/my-measures-graph-highcharts.module'
        ).then(m => m.MyMeasuresGraphHighchartsPageModule)
    }
  ]
};

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    MyMeasuresStoreModule,
    RouterModule.forChild(pageModule.routes)
  ],
  providers: [
    MyMeasuresGraphGuard,
    { provide: CORE_PAGE_MODULE, useValue: pageModule, multi: true },
    { provide: CORE_I18N_FOLDER, useValue: './my-measures/i18n/', multi: true }
  ]
})
export class MyMeasuresModule {}
